import script from "./AddCourseForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCourseForm.vue?vue&type=script&setup=true&lang=js"

import "./AddCourseForm.vue?vue&type=style&index=0&id=566b158c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-566b158c"]])

export default __exports__